// extracted by mini-css-extract-plugin
export default {"tagline":"TypewriterTagline_tagline__sZa7d","text":"TypewriterTagline_text__UvQRj","cursor":"TypewriterTagline_cursor__DYkRb","blink":"TypewriterTagline_blink__jKMGQ"};